import { useEffect, useState } from 'react';
import { type PatchedCustomerTagList } from '@hungryroot/rest';
import { useTagGroup } from '@hungryroot/rest-hooks';
import { useCustomerTagGroup } from '@hungryroot/tags';
import {
  type CustomerPreferenceLoader,
  type TagDataLoader,
  type TagLoaderComponent,
} from '../types';
import { getShouldRenderTag } from '../utils';

/** Gets all the tags for the passed in tag group id*/
export const useTagsData: TagDataLoader = (tagGroupId) => {
  const tagGroup = useTagGroup(tagGroupId);
  const { data: tagGroupData } = tagGroup || {};
  const queryTags = tagGroupData?.tags;

  return queryTags || [];
};

/** Gets all the customer preferences for the passed in tag group id*/
export const useCustomerPreferenceLoader: CustomerPreferenceLoader = ({
  customerId,
  tagGroupId,
  setCustomerTags,
}) => {
  const { data: customerTagGroupData, status: customerTagGroupStatus } =
    useCustomerTagGroup(tagGroupId);

  useEffect(() => {
    if (
      customerTagGroupStatus !== 'success' ||
      customerTagGroupData === undefined
    ) {
      return;
    }

    const prefs = customerTagGroupData.results.map((obj) => {
      return {
        customer_id: customerId,
        preference: obj.preference,
        tag: obj.tag,
      };
    });

    setCustomerTags(prefs);
  }, [
    customerTagGroupData,
    customerTagGroupStatus,
    customerId,
    tagGroupId,
    setCustomerTags,
  ]);
};

export const DefaultTagLoader: TagLoaderComponent = (props) => {
  const { children, tagGroupId, buildSelectedMap } = props;
  const baseTags = useTagsData(tagGroupId);

  const tags = baseTags.filter(getShouldRenderTag(tagGroupId));

  const [customerTags, setCustomerTags] = useState<PatchedCustomerTagList[]>(
    []
  );

  const selectedMap = buildSelectedMap({ customerTags, queryTags: baseTags });

  useCustomerPreferenceLoader({ ...props, setCustomerTags });
  return children({ tags, selectedMap, customerTags });
};
